import React from "react";

export const BasicImportCss = () => {

    return (
        <React.Fragment>

            <link rel="stylesheet" media="all" href={process.env.PUBLIC_URL + "/lager/css/animate.css"}/>
            <link rel="stylesheet" media="all" href={process.env.PUBLIC_URL + "/lager/css/bootstrap.css"}/>
            <link rel="stylesheet" media="all" href={process.env.PUBLIC_URL + "/lager/css/font-awesome.css"}/>
            <link rel="stylesheet" media="all" href={process.env.PUBLIC_URL + "/lager/css/linear-icons.css"}/>
            <link rel="stylesheet" media="all" href={process.env.PUBLIC_URL + "/lager/css/magnific-popup.css"}/>
            <link rel="stylesheet" media="all" href={process.env.PUBLIC_URL + "/lager/css/owl.carousel.css"}/>
            <link rel="stylesheet" media="all" href={process.env.PUBLIC_URL + "/lager/css/ion-range-slider.css"}/>
            <link rel="stylesheet" media="all" href={process.env.PUBLIC_URL + "/lager/css/theme.css"}/>

            <link href="https://fonts.googleapis.com/css?family=Poppins:400,500,600" rel="stylesheet"/>
            <link href="https://fonts.googleapis.com/css?family=Open+Sans:400,700&amp;subset=latin-ext" rel="stylesheet"/>
            <div className="page-loader"></div>

        </React.Fragment>
    );
}